import * as React from 'react';

import { VisuallyHidden } from '@coursera/cds-core';

import type { CoachItemType } from 'bundles/coach-item/common/types';
import type { Item } from 'bundles/learner-progress/types/Item';
import { getFormattedTitlePrefix, getFormattedTitlePrefixForA11y } from 'bundles/learner-progress/utils/Item';
import { useCourseAiGradingContext } from 'bundles/peer/components/ai-grading/CourseAiEligibilityProvider';

type Props = {
  computedItem: Item;
  isGuidedProject?: boolean;
  coachItemType?: CoachItemType | undefined;
};

export const NavItemName = ({ computedItem, isGuidedProject, coachItemType }: Props) => {
  const { getItemAiGradingEligibility, getItemFullyAiGradingEligibility } = useCourseAiGradingContext();
  const isAiGradingEligible =
    getItemAiGradingEligibility(computedItem.id) || getItemFullyAiGradingEligibility(computedItem.id);

  const formattedTitlePrefix = getFormattedTitlePrefix(
    computedItem,
    isGuidedProject,
    isAiGradingEligible,
    coachItemType
  );
  const formattedTitlePrefixForA11y = getFormattedTitlePrefixForA11y(computedItem, isGuidedProject);

  return (
    // TODO: Switch to coursera-ui instead of using a semantically questionable className
    <div className="rc-NavItemName caption-text">
      {!!formattedTitlePrefix && <strong>{`${formattedTitlePrefix}: `}</strong>}

      {!!formattedTitlePrefixForA11y && (
        <VisuallyHidden component="span" className="rc-A11yScreenReaderOnly">
          {formattedTitlePrefixForA11y}
        </VisuallyHidden>
      )}

      {computedItem.name}
    </div>
  );
};

export default NavItemName;
